import React from 'react'
import { inject, observer } from 'src/core/store'
import './index.less'
import { getlangV2, setlang } from 'src/helper/getlang'
import { setDocumentTitle, setUidToken } from 'src/helper/tool'
import langM from './lang'

@inject('store')
@observer
export default class extends React.Component {
  constructor(props) {
    super(props)
  }
  state = {
    lang: langM.en,
    language: "ar",
  }

  async closeWebview() {
    closeWebview()
  }

  async componentWillMount() {
    let { language } = this.props.location.query
    language =await getlangV2(language, langM)
    console.log("language", language)
    this.setState({
      lang: setlang(language, langM),
      language: language,
    })
    if (language=='en') {
      setDocumentTitle('Announcement')
    }else if (language=='tr') {
      setDocumentTitle('Duyuru')
    }else{
      setDocumentTitle('إعلان')
    }
    let uid = await setUidToken(this.props.location.query)
    await this.RunOnStart(uid)
  }

  async RunOnStart(uid) {
  }

  render() {
    let { language, lang } = this.state
    function langBgShow() {
      if (language == 'zh') {
        return 'mr-zh'
      } else if (language == 'ar') {
        return 'mr-ar'
      }
      else if (language == 'tr') {
        return 'mr-tr'
      }
      else if (language == 'en') {
        return 'mr-en'
      }
    }
    return (
      <div className="malicious-refund-wrap">
        <div
          className={`mr-bg ${langBgShow()}`}
        ></div>
        <div className="mr-content">
          <div className="mr-txt">
            <div className="title">{lang.title}</div>
            <div className="txt1"  style={{textAlign:`${this.state.language == 'ar'?'right':''}`}} dangerouslySetInnerHTML={{ __html: lang.txt1 }}></div>
            <div className="txt2"  style={{textAlign:`${this.state.language == 'ar'?'right':''}`}} dangerouslySetInnerHTML={{ __html: lang.txt2 }}></div>
            <div className="txt3" style={{textAlign:`${this.state.language == 'ar'?'right':''}`}}>{lang.txt3}</div>
          </div>
        </div>
        <div className="mr-pattern-1"></div>
        <div className="mr-pattern-2"></div>
        <div style={{ display: 'none' }}>
          <img src="/img/app/maliciousrefund/tr_bg.png" alt="" />
          <img src="/img/app/maliciousrefund/ch_bg.png" alt="" />
          <img src="/img/app/maliciousrefund/ar_bg.png" alt="" />
          <img src="/img/app/maliciousrefund/en_bg.png" alt="" />
        </div>
      </div >
    )
  }
}



// WEBPACK FOOTER //
// src/pages/app/refund/index.js